<template>
    <div :class="['image-container', currentStyle]" :style="cssVars">
        <template v-if="value.data && value.data.length > 0">
             <a v-for="(item, index) in value.data" :key="index"
                :href="item.link || 'javascript:void(0)'" :target="item.link ? '_blank' : '_self'" :rel="item.link ? 'noopener noreferrer' : ''">
                <img :src="decodeURIComponent(item.url)">
             </a>
        </template>
        <template v-else>
            <NullView tip="[图片]" :height="120" />
        </template>
    </div>
</template>

<script>
import NullView from "./NullView";

export default {
    name: 'ImageView',
    components: {
        NullView
    },
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cssVars() {
            return {
                '--image-width': this.value.imageWidth + '%',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.image-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    overflow-y: hidden;
    box-sizing: border-box;

    a {
        display: block;
        margin-bottom: 10px;
        overflow: hidden;
    }

    a:last-child {
        margin-bottom: 0;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    // style1：每行一张图片，居中显示
    &.style1 {
        justify-content: center;

        a {
            width: 100% !important;
            text-align: center;
        }

        img {
            width: var(--image-width);
        }
    }

    // style2：每行一张图片，居左显示
    &.style2 {
        justify-content: flex-start;

        a {
            width: 100% !important;
            text-align: left;
        }

        img {
            width: var(--image-width);
        }
    }

    // style3：每行一张图片，居右显示
    &.style3 {
        justify-content: flex-end;

        a {
            width: 100% !important;
            text-align: right;
        }

        img {
            width: var(--image-width);
        }
    }


    // style4：每行多张图片，均匀分布显示
    &.style4 {
        justify-content: space-between;

        a {
            width: var(--image-width) !important;
            text-align: center;
        }
    }
}
</style>